<template lang="pug">
.content
  .row
    .col-md-12
      div.box_header
        label.title Tổng quan
        .clearfix
      div.row
        div.box-content.col-md-6.col-sm-6.col-xs-12
          .box-pc-create(v-bind:class="[lstData.length === 0 ? '' : 'render-list']")
            div(v-if="lstData.length === 0")
              .item-pc-title CỘNG ĐỒNG CỦA TÔI
              .item-pc-img
                img(src="../../assets/images/pc/bg_myPC.svg")
              .item-pc-bottom
                span Bạn đã sẵn sàng để tạo 1 cộng đồng cho riêng mình? 
                span OBee sẽ giúp bạn
                router-link.button(to="/general_step") Tạo cộng đồng ngay!
            div(v-else)
              .item-pc-title CỘNG ĐỒNG CỦA TÔI
              router-link.button-plus(to="/general_step") + Thêm mới cộng đồng
              .clearfix
              .item-pc-list
                div(v-for="(itemPC, index) in lstData")
                  PCItem(:item="itemPC" :obj_id="itemPC.id")
                  .clearfix
                .clearfix
</template>
<script>
import gql from 'graphql-tag'
import graphql from '../Model/graphql'
import PCItem from '../PC/item'
export default {
  components: {
    PCItem
  },
  data() {
    return {
      lstData: [],
      loader: null
    }
  },
  methods: {
    numberWithCommas(number) {
      if (number !== undefined && number !== null) {
        return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
      }
      return 0
    },
    show() {
      this.loader = this.$loading.show({
        color: '#ffffff',
        loader: 'spinner',
        width: 60,
        height: 60,
        backgroundColor: '#000000',
        opacity: 0.5,
        zIndex: 9999,
        container: null,
        canCancel: true,
        onCancel: this.onCancel
      })
    }
  },
  mounted () {
    this.show()
    if (this.$route.params.reload !== undefined && this.$route.params.reload === 1) {
      this.$apollo.queries.lstData.refresh()
    }
    this.loader.hide()
  },
  watch: {
    '$route': function(from, to) {
      if (from !== to) this.$apollo.queries.lstData.refresh()
    }
  },
  apollo: {
    lstData: {
      query: gql(graphql.GET_PC_TO_USER),
      fetchPolicy: 'no-cache',
      variables() {
        return {
          user_id: this.$store.getters.user,
          limit: 10,
          orderBy: {created_at: 'desc'}
        }
      },
      update: data => {
        return data.v_pc_teacher
      },
      error(error) {
        if (error.graphQLErrors[0].extensions.code === 'invalid-jwt') {
          this.$router.go(0)
        }
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.box_header{
    label.title{
        text-align: left; 
        font-size:20px;
        font-weight:bold;
        font-family: 'adobe-clean', sans-serif;
        letter-spacing: 0px;
        color: #5F6468;
        display:inline-block
    }
}
.box-content{margin-top: 15px;
    .box-pc-create{background: #FFFFFF 0% 0% no-repeat padding-box;box-shadow: 0px 1px 2px #00000029;border-radius: 3px; padding: 15px; width: 100%;
      &.render-list{
        .item-pc-title{display: inline-block;}
        .button-plus{float: right; color:#1A0DAB; font-size: 13px;}
        .item-pc-list{ margin-top: 20px;
          .render-item-pc{ margin-bottom: 15px;position: relative; float: left;width: 100%;}
        }
      }
      .item-pc-title{text-align: left; font-size: 15px; font-weight: bold; font-family: Helvetica;letter-spacing: 0px;color: #343A40;text-transform: uppercase;}
      .item-pc-img{margin: 30px 0 60px 0;text-align: center;height: 150px; display: flex;justify-content: center;align-items: center;
        img{max-width: 100%; height: auto;}
      }
      .item-pc-bottom{text-align: center;
        span{display: block;text-align: center;font-size: 15px;letter-spacing: 0px;color: #333333;}
        .button{line-height: 48px; height: 48px; width: 328px;display: block; margin: 30px auto 0;background: #FFD311 0% 0% no-repeat padding-box; border-radius: 5px;border: 0 none;color: #23180A; font-size: 14px;}
      }
    }
}
</style>



// WEBPACK FOOTER //
// index.vue?277ca71c